import styled, { css } from "styled-components";
import { Section } from "../../components/Section/Section";
import { Heading } from "../../components/Heading/Heading";
import { Title } from "../../components/Title/Title";

interface GalleryWithTabsSection extends Section {
  backgroundcolor?: string
}

interface GalleryWithTabsTitle {
  color?: string
}

export const GalleryWithTabsSection = styled(Section)<GalleryWithTabsSection>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: ${props => props.backgroundcolor || "var(--general-background, #F1F5F9)"};
`;

export const GalleryWithTabsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    max-width: 76rem;
    align-items: center;
    gap: 2rem;
  }

  @media (max-width: 767px) {
    gap: 1rem;
  }
`;

export const GalleryWithTabsTitle = styled(Heading)<GalleryWithTabsTitle>`
  text-align: center;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: none;
  color: ${props => props.color || "var(--text-title, #080404)"};
`;

export const GalleryWithTabsCardDesktop = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const GalleryWithTabsCardMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }

  @media (max-width: 767px) {
    padding-left: 1.5rem;
  }
`;

export const CarouselContainer = styled.div`
  max-width: 1216px;
`;

export const CarouselContainerInner = styled.div`
  margin-left: -1rem;

  .embla__slide {
    padding-left: 1rem;
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 80%;
  }
`;

export const CarouselProgress = styled.div`
  width: 100%;

  @media (max-width: 767px) {
    padding-right: 1.5rem;
  }
`;

export const TextCard = styled(Title)<{ textColor: string }>`
  padding-left: 16px;
  padding-right: 16px;
  color: ${({ textColor }) => textColor || "var(--cards-title, #0f172a)"};

  @media (max-width: 768px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`

export const TextContainer = styled.div<{ bgColor: string }>`
  width: 100%;
  flex: 1;
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-right-radius: var(--design-card-border-radius, 8px);
  border-bottom-left-radius: var(--design-card-border-radius, 8px);
  background-color: ${({ bgColor }) => bgColor || "var(--cards-background, #ffffff)"};

  @media (max-width: 767px) {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  @media (min-width: 767px) {
    max-width: 384px;
  }
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 767px) {
    max-width: 384px;
  }
`

export const GalleryWithTabsImage = styled.div`
  @media (max-width: 768px) {
    .image {
      width: 384px;
    }
  }

  .image {
    width: 100%;
    object-fit: cover;
    border-top-right-radius: var(--design-card-border-radius, 8px);
    border-top-left-radius: var(--design-card-border-radius, 8px);
  }
`;
